// extracted by mini-css-extract-plugin
export default {"container":"privacy_container__PcLp7"};